// Lightweight first-party analytics tracker.
// No cookies, no third-parties: sends a small JSON to /api/track.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const KEY = 'cl_sid';

const getSessionId = () => {
  if (typeof window === 'undefined') return 'ssr';
  let sid = window.sessionStorage.getItem(KEY);
  if (!sid) {
    sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    window.sessionStorage.setItem(KEY, sid);
  }
  return sid;
};

const isMobile = () => {
  if (typeof navigator === 'undefined') return false;
  return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
};

const track = (event, extra = {}) => {
  if (typeof window === 'undefined') return;
  // Skip admin/login pages entirely
  const path = window.location.pathname || '/';
  if (path.startsWith('/admin') || path.startsWith('/login')) return;

  const payload = {
    session_id: getSessionId(),
    path,
    referrer: document.referrer || '',
    is_mobile: isMobile(),
    language: (navigator.language || '').slice(0, 5),
    event,
    ...extra,
  };

  // Use fetch keepalive so it also works during page unload
  try {
    fetch(`${BACKEND_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (_e) {
    // fail silently
  }
};

export const trackPageView = () => track('pageview');

export const trackArtworkView = (artwork) => {
  if (!artwork) return;
  track('artwork_view', {
    artwork_id: String(artwork.id || ''),
    artwork_title: String(artwork.title || ''),
  });
};

export const trackEvent = (name, extra = {}) => track(name, extra);
